<template>
  <div class="md-layout md-alignment-center-center flex-1">
    <div
      class="md-layout-item md-small-size-100 md-large-size-50 md-xlarge-size-33"
    >
      <div style="text-align:center; margin-bottom:20px">
        <img src="@/assets/img/logos/logo-sml.png" width="300px" />
      </div>
      <md-card>
        <md-card-header data-background-color="secondary">
          <h4 class="title">Welcome to the SML Buyers Hub</h4>
          <p class="category">
            Enter your Mobile or Email below to login/register:
          </p>
        </md-card-header>
        <md-card-content>
          <p style="font-size: 16px; padding: 1rem">
            <strong>
              Are you interested in becoming a buyer at Sydney Markets? </strong
            ><br /><br />
            If you're a business owner (e.g. greengrocer, florist, events,
            caterer) who requires wholesale volumes of fresh flowers, fruits and
            vegetables, begin your registration on this page.<br /><br />
            <strong>
              A Buyer's Pass is not required for entry to Flower Market after
              6am Mon-Fri, and 5am-11am Saturday
            </strong>
          </p>

          <login-form />
        </md-card-content>
      </md-card>

      <div class="text-center">
        <a
          class="fw-bold fs-5"
          href="https://www.sydneymarkets.com.au/markets/buyers-pass-faq.html"
          target="_blank"
          >Buyer’s Pass FAQs</a
        >
      </div>

      <router-link
        to="/parking-pass"
        class="card prime-park-card h-100 shadow mt-5"
      >
        <div
          class="card-body d-flex align-items-center justify-content-center text-white"
        >
          <h4 class="text-center mb-0 text-white">
            <md-icon
              style="color: white !important; font-size: 1.4em !important; margin-right: 20px"
              >local_parking</md-icon
            >
            Purchase Parking Passes Only
          </h4>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import LoginForm from "../Forms/LoginForm.vue";
export default {
  components: { LoginForm },
  mounted() {
    if (this.$route.query.reg && this.$route.query.reg === "true") {
      this.$toast.open({
        message: "Registration successful; please log in.",
        type: "success",
        position: "top",
      });
    }
  },
};
</script>

<style scoped>
.prime-park-card {
  background-color: #2560a6;
}
</style>
